module.exports = __webpack_public_path__ + "static/media/Pokana-27.05.2024.3dd5d99f.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/files/informationInversors/2024/Pokana-27.05.2024.pdf
// module id = 92
// module chunks = 0